export default "__VITE_ASSET__DDr$AtD$__"